<template>
    <p-modal name="exportInventoryByFixtureModal"
                label="Export Inventory By Fixture"
                ref="exportInventoryByFixtureModal"
                size="lg"
                @show="loadParameters">
        <template v-slot:default>
            <div class="container-fluid content-wrapper">
                <b-row cols="1" >
                    <b-col>
                        <p-select label="Fixture"
                                    v-model="reportParameters.fixture"
                                    :options="fixtureOptions"
                                    add-empty-option />
                        <p-select label="Area"
                                    v-model="reportParameters.area"
                                    :options="areaOptions"
                                    add-empty-option />
                        <p-select v-model="reportParameters.sortBy"
                                    name="Sort By"
                                    label="Sort By"
                                    :options="sortByInFixtureReport" />

                    </b-col>
                </b-row>
                <UserReportTemplate
                    :user-report-template-options="userReportTemplateOptions"
                    v-model:selected-user-report-template-id="selectedUserReportTemplateId"
                    :selected-user-report-template="selectedUserReportTemplate"
                    v-model:template-name="templateName"
                    @selected-object="applyUserReportTemplate($event)" />
            </div>
        </template>
        <template v-slot:modal-footer >
            <b-row>
                <b-col class=" mb-3 text-center">
                        <p-button  :is-busy="isBusy" variant="outline-primary" @click="exportInventoryByFixtureReport('csv')"> Export CSV</p-button>
                    </b-col>
            </b-row>
        </template>
    </p-modal>
</template>

<script>

import reports from './reports.js';
import ReportTemplates from '@/components/mixins/ReportTemplates.js';
import UserReportTemplate from '@/components/UserReportTemplate.vue';

export default {
    props: {},
    mixins: [reports, ReportTemplates],
    data() {
        return {
            // Identifies which report saved templates belong to; must match the report name in Reports.vue.
            reportName: 'Inventory By Fixture',
        };
    },
     components: {
        UserReportTemplate
    },
    methods: {
        async exportInventoryByFixtureReport(type) {
            if (!(await this.saveUserReportTemplate())) {
                return;
            }

            let destination = type === 'csv' ? '/physicalInventory/exportInventoryByFixtureCsv' : "";
            let message = `Inventory By Fixture Csv report generated successfully.`;
            let fileName = 'Inventory By Fixture';
            this.exportReport(type, destination, message, fileName);
        },

        async show() {
            this.$refs.exportInventoryByFixtureModal.show();
            await this.loadUserReportTemplates();
        },

        // ReportTemplates hook: return false when anything in the saved template can no longer be
        // selected, and the mixin warns and loads nothing. Fixtures and areas come from the open
        // physical inventories for the current location, so they are checked against the loaded
        // lists; sortBy is checked against its fixed local list.
        async validateReportParameters(savedParameters) {
            // loadParameters kicks this off on @show without awaiting it, so the lists can still
            // be in flight here. Awaiting avoids rejecting a good template against empty lists.
            await this.loadFixtureAreaOptions();

            if (savedParameters.fixture
                && !this.fixtureOptions.some(fixtureOption => fixtureOption.value === savedParameters.fixture)) {
                return false;
            }

            if (savedParameters.area
                && !this.areaOptions.some(areaOption => areaOption.value === savedParameters.area)) {
                return false;
            }

            return this.sortByInFixtureReport.some(sortByOption => sortByOption.value === savedParameters.sortBy);
        }
    }
};

</script>

<style scoped></style>
